export default {
    filters: {
        title: "Filtres",
        removeFilter: "Supprimer le filtre",
        filterIntensity: "Intensité du filtre",
        duotone: {
            title: "Duotone",
            desert: "Désert",
            peach: "Pêche",
            clash: "Conflit",
            plum: "Prune",
            breezy: "Frais",
            deepBlue: "Profond Bleu",
            frog: "Grenouille",
            sunset: "coucher de soleil",
        },
        blackAndWhite: {
            title: "En noir et blanc",
            ad: "1920 après Jésus-Christ",
            greyed: "Grisonnant",
            dusty: "Poussiéreux",
            litho: "Lithographie",
            sepia: "Sépia",
            weathered: "Usé ",
            hardStuff: "Trucs Difficiles",
        },
        vintage: {
            title: "Vintage",
            polaroid: "Polaroid",
            sunny: "Sunny 70's",
            oldTimer: "Vieux Routard",
            inferno: "Inferno",
            snappy: "Vif",
        },
        smooth: {
            title: "Lisse",
            chestnut: "Châtaigne",
            softy: "Tendre",
            pebble: "Caillou",
            moss: "Mousse",
            lemon: "Le citron",
            greenGap: "Écart vert",
        },
        cold: {
            title: "Froid",
            colla: "Colle",
            solanus: "Solanus",
            kalmen: "Kalmen",
            jorah: "Joran",
            levante: "l'est",
            zephyr: "Zéphyr",
        },
        warm: {
            title: "Chaud",
            golden: "Doré",
            lowFire: "Feu doux",
            sunrise: "Le lever du soleil",
            flatBack: "Dos plat",
            pumpkin: "Potiron",
        },
    },
};
